import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { DateTime } from "./DateTime";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorDateTimePropertyValues =
    PropertyEditorPropertyValues
    & {
    };

export type PropertyEditorDateTimeProperties = {
    [name in keyof PropertyEditorDateTimePropertyValues]: Property<PropertyEditorDateTimePropertyValues[name]>
};

export interface IPropertyEditorDateTime extends IPropertyEditor, PropertyEditorDateTimeProperties
{
}

export class PropertyEditorDateTime extends PropertyEditor implements IPropertyEditorDateTime
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorDateTime";
    public static override className = "PropertyEditorDateTime";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorDateTimePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new DateTime(),
            }
        };
    }

    // #endregion

    // #endregion
}
